import Vue from 'vue'
import createApp from 'wap/plugins/create-app.js'
import VInput from 'fe-vui/input'
import VButton from 'fe-vui/button'
import VPopup from 'fe-vui/popup'
import App from './App.vue'

Vue.use(VInput)
Vue.use(VButton)
Vue.use(VPopup)

createApp(App, { exclude: ['zm'] })
